import React from "react"

// Simplified transition wrapper - just renders children
// Page transitions handled by CSS if needed
const Transition = ({ children, location }) => {
    if (!location) {
        return null;
    }
    return <>{children}</>;
}

export default Transition
